import React from 'react';
import {withRouter} from 'react-router-dom';
import {Col, Container, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExclamation, faSpinner} from '@fortawesome/free-solid-svg-icons';
import {Button, DatePicker, Form, Input, notification, Popconfirm, Select, Space, Table, TimePicker} from 'antd';
import moment from 'moment';
import Api from '../../../../services/Api';
import _ from 'lodash';
import HelperGeneral from '../../../../helpers/HelperGeneral';
import Countdown, {zeroPad} from 'react-countdown';
import UserInfo from '../../../auth/UserInfo';
import {QrcodeOutlined} from '@ant-design/icons';
import {setGlobalSpinner} from "../../../../services/redux/actions/GeneralAction";

const {Option} = Select;

class EarnPoints extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
            product_data: [],
            transactions: [],
            pagination: {
                current: 1,
                pageSize: 10,
            },
            loading: true,
            productInputLoading: false,
            sliders: [],
            sliderLoading: true,
            dateFilterType: 'month',
        };
        this.windowResize = this.windowResize.bind(this);
        this.productAddForm = React.createRef();
        this.productInput = React.createRef();
        const PickerWithType = ({type, onChange}) => {
            if (type === 'time') return <TimePicker onChange={onChange}/>;
            if (type === 'date') return <DatePicker onChange={onChange}/>;
            return <DatePicker picker={type} onChange={onChange}/>;
        };

        this.product_history_column = [
            {
                title: 'İşlem Tarihi',
                dataIndex: 'usedAt',
                sorter: false,
                width: 180,
                render: (name, record) => moment(record?.usedAt).format('DD.MM.YYYY HH:mm'),
            },
            {
                title: 'Ürün Barkodu',
                dataIndex: 'productBarcode',
                render: (name, record) => record?.productBarcode || record?.productBarcode?.length > 0 ? record?.productBarcode : '-',
            },
            {
                title: 'Ürünün İsmi',
                dataIndex: 'productName',
                render: (name, record) => record?.productName ?? '-',
            },
            {
                title: 'Puan Kodu',
                dataIndex: 'code',
                render: (name, record) => record?.code || record?.code?.length > 0 ? record?.code : '-',
            },
            {
                title: 'Kazanılan Puan',
                dataIndex: 'points',
                render: (name, record) => record?.points ? '+' + record?.points + ' Puan' : '-',
            },
            // {
            //     title: 'Eczacı Hakediş Takip',
            //     dataIndex: 'delivery',
            //     render: (name, record) => record?.delivery ?? '-',
            // },
            // {
            //     title: '',
            //     dataIndex: 'operation',
            //     width: 130,
            //     render: (text, record) => (
            //         <Popconfirm
            //             title="Emin misiniz?"
            //             overlayClassName={'border-radius-8'}
            //             onConfirm={() => this.transactionRemove(record)}
            //         >
            //             <Button className={'cancel-button'}>İşlemi İptal Et</Button>
            //         </Popconfirm>
            //
            //     ),
            // },
        ];

        this.timerProductAdd = null;
        this.qrcodeArea = React.createRef();
    }

    async componentDidMount() {
        window.addEventListener('resize', this.windowResize);

        const {pagination} = this.state;
        this.getTransactions({pagination});

        new Event('qrCodeSend', {
            bubbles: true,
            cancelable: true,
            composed: false,
        });
        window.addEventListener('qrCodeSend', (e) => {
            this.productAdd(e?.detail?.code);
            this.qrcodeArea.current.scrollIntoView();
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResize);
    }

    windowResize = () => {
        this.setState({
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
        });
    };

    qrScanner = () => {
        window.isNativeApp = true;
        window.ReactNativeWebView.postMessage(JSON.stringify({scanner: true}));
        return true;
    };

    // transactionRemove = (record) => {
    //     this.setState({
    //         loading: true,
    //     }, () => {
    //         Api.transactionRemove(record?.transactionId).then(() => {
    //             this.setState({loading: false}, () => {
    //                 const {pagination} = this.state;
    //                 this.getTransactions({pagination});
    //                 notification['success']({
    //                     message: 'Başarılı!',
    //                     description:
    //                         'İşlem iptali başarıyla gerçekleşti',
    //                 });
    //             });
    //         }).catch((e) => {
    //             this.setState({loading: false}, () => {
    //                 HelperGeneral.alert(e);
    //             });
    //         });
    //     });
    // };

    productAddEvent = (e) => {
        this.productAdd(e?.code);
    };

    productAdd = (code, result = null) => {
        const index = this.state.transactions.length;
        this.setState({
            transactions: [...this.state.transactions, {code}],
            productInputLoading: true
        }, () => {
            const data = {
                code: code
            }
            Api.transactionAdd(data).then((a) => {
                this.setState({
                    transactions: _.remove(this.state.transactions, index),
                }, () => {
                    Api.getCustomer().then(r2 => {
                        const {remember} = UserInfo.dataCheck();
                        UserInfo.setUserInfo(r2?.data, remember);
                    }).catch((e) => {
                        HelperGeneral.alert(e);
                    });
                    this.props.getTop5Products();
                    HelperGeneral.alert('Puan başarılı bir şekilde hesabınıza eklendi!', 'success');
                    this.productAddForm?.current?.resetFields();
                    this.getTransactions({pagination: {current: 1, pageSize: 10}});
                    if (result) return result();
                });
            }).catch((e) => {
                const transactions = this.state.transactions;
                transactions[index]['error'] = HelperGeneral.getErrorText(e, code);
                transactions[index]['errorTime'] = Date.now() + 7000;
                transactions[index]['key'] = HelperGeneral.uuidv4();
                this.productAddForm?.current?.resetFields();
                this.setState({
                    transactions: transactions,
                    productInputLoading: false,
                }, () => {
                    if (result) return result();
                });
            });
        });
    };

    productInputChangeEvent = (e, rawCode = null) => {
        let value = rawCode ? rawCode : e?.target?.value;
        clearTimeout(this.timerProductAdd);
        let ms = 75; //!INFO milliseconds
        this.timerProductAdd = setTimeout(() => {
            const lowerVal = value.toLowerCase();
            const isUrlOrMalformed = lowerVal.includes('.com/qr') || lowerVal.includes('com.qr.') || lowerVal.includes('qr.') || lowerVal.includes('/qr/') || /[Çç]|[*＊]/.test(value);
            if (isUrlOrMalformed) {
                const code = this.extractCode(value);
                if (code) {
                    this.productAddForm?.current.setFieldsValue({code});
                    this.productAdd(code);
                }
            }
        }, ms);
    };

    extractCode = (raw) => {
        let v = String(raw ?? "").trim();
        if (!v) return "";

        const extracted = HelperGeneral.extractQrcodeFromUrlOrRaw(v);
        if (extracted?.code) return extracted.code;

        try {
            v = v.normalize("NFKC");
        } catch {
        }

        v = HelperGeneral.normalizeScannerQrInput(v);
        v = v
            .replace(/[＊∗⋆✱✳✴]/g, "*")
            .replace(/[–—−]/g, "-");

        const iStar = v.lastIndexOf("*");
        const iDash = v.lastIndexOf("-");
        const i = Math.max(iStar, iDash);

        let tail = i !== -1 ? v.slice(i + 1) : v;

        tail = tail.split(/[\/\.]/).filter(Boolean).pop() || tail;

        const chunks = tail.match(/[A-Za-z0-9]+/g);
        return chunks ? chunks[chunks.length - 1] : "";
    };

    handleScan = (e) => {
        e.preventDefault();

        const value = e.target.value;
        const code = this.extractCode(value);

        if (!code) return;

        this.productAddForm?.current.setFieldsValue({code});
        this.productAdd(code);
    };

    findProductInput = (e) => {
        if (this.productInput.current.state.value === '' || this.productInput.current.state.value === undefined) {
            this.setState({
                transactions: [
                    {
                        required: true,
                        error: 'Ürün kodu girişi zorunludur',
                    },
                ],
            });
        }
    };

    handleTableChange = (pagination, filters, sorter) => {
        this.getTransactions({
            pagination,
        });
        HelperGeneral.scrollToClassName('.ant-tabs-nav');
    };

    getTransactions = (params = {}) => {
        this.setState({loading: true}, () => {
            Api.getTransactions(params.pagination.current, params.pagination.pageSize).then(response => {
                this.setState({
                    loading: false,
                    product_data: response?.data?.data,
                    pagination: {
                        ...params.pagination,
                        total: response?.total,
                    },
                });
            }).catch((e) => {
                this.setState({
                    loading: false,
                    productInputLoading: false,
                }, () => HelperGeneral.alert(e));
            });
        });
        setTimeout(() => {
            this.setState({productInputLoading: false});
        }, 2000);
    };

    render() {
        const {innerWidth, product_data, pagination, loading, transactions} = this.state;

        return (
            <>
                <div className={'product-area mt-0 ' + (transactions.length > 0 ? 'processing' : '')} style={{paddingTop: '0px'}}>
                    <Row className={'h-100'}>
                        <Col
                            className={'my-auto'}
                            xs={12}
                            sm={12}
                            md={12}
                            xl={true}
                        >
                            <div className={'description-area'} ref={this.qrcodeArea}>
                                <div>
                                    <p className={'t1'}>Orzax SHINIQ Kazan!</p>
                                    <p className={'t2'}>
                                        Satışını yaptığınız Orzax SHINIQ ürününün üzerindeki QR kodu okutun.
                                        Eğer QR kodunu okutamıyorsanız, ürünün kodunu manuel olarak sisteme girin.
                                        Her satıştan puan kazanın.
                                        Biriktirdiğiniz puanlarla hediyeler kazanın!
                                    </p>
                                </div>
                                {/*<Button className={'current-campaigns-btn'} onClick={() => HelperGeneral.pageChange(this, '/kampanyalar/guncel-kampanyalar')}>*/}
                                {/*    <p className={'t3'}>Güncel Kampanyalar</p>*/}
                                {/*</Button>*/}
                            </div>
                        </Col>
                        <Col
                            className={'my-auto'}
                            xs={12}
                            md={12}
                            xl={'auto'}
                        >
                            <Form onFinish={(e) => this.productAddEvent(e)} ref={this.productAddForm}>
                                <Container>
                                    <Row className={'p-0'}>
                                        <Col
                                            xs={12}
                                            md={'auto'}
                                            style={{position: 'relative'}}
                                        >
                                            <Form.Item
                                                name={'code'}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '',
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    autoComplete={'off'}
                                                    placeholder={'Ürün QR\'ını okutunuz veya kodunu giriniz.'}
                                                    onChange={(e) => this.productInputChangeEvent(e)}
                                                    // onPressEnter={(e) => this.handleScan(e)}
                                                    ref={this.productInput}
                                                    disabled={this.state.productInputLoading}
                                                />
                                            </Form.Item>
                                            {
                                                navigator.userAgent === 'inntheboxMobileSP' && (
                                                    <div className={'qr-area'}>
                                                        <QrcodeOutlined style={{fontSize: '20px'}} onClick={() => this.qrScanner()}/>
                                                    </div>
                                                )
                                            }
                                        </Col>
                                        <Col
                                            xs={12}
                                            md={true}
                                            style={{marginRight: '10px'}}
                                        >
                                            <Button htmlType={'submit'} onClick={(e) => this.findProductInput(e)}>Puan Kazan</Button>
                                        </Col>
                                    </Row>
                                </Container>
                            </Form>
                        </Col>
                        <Col xs={12} className={'p-0'}>
                            <div className={'process-area'}>
                                {
                                    transactions?.map((v, i) => (
                                        <div className={(v?.error ? 'error' : '')} key={i}>
                                            <div>
                                                {
                                                    !v?.required ? (
                                                        v?.error ? (
                                                            <>
                                                                Üzgünüz, {v?.code} numaralı ürün eklenemedi: <span style={{marginLeft: '6px'}}> {v?.error}</span>
                                                            </>
                                                        ) : (
                                                            v?.code + ' numaralı ürün için işlem devam ediyor...'
                                                        )
                                                    ) : (
                                                        v?.error
                                                    )
                                                }
                                            </div>
                                            <div>
                                                {
                                                    v?.error && (
                                                        <Countdown
                                                            precision={0}
                                                            renderer={({minutes, seconds}) => (
                                                                <span className={'pe-2 countdown d-none'}>
                                                                    Kapanacak: {zeroPad(seconds)}
                                                                </span>
                                                            )}
                                                            onComplete={() => {
                                                                const transactions = _.remove(this.state.transactions, (v1, i1) => {
                                                                    return i1 !== i;
                                                                });
                                                                this.setState({transactions: transactions});
                                                            }}
                                                            date={v.errorTime}
                                                            key={v.key}
                                                            autoStart={true}
                                                        />
                                                    )
                                                }
                                                <FontAwesomeIcon
                                                    className={'d-none'}
                                                    icon={v.error ? faExclamation : faSpinner}
                                                    spin={!v.error}
                                                />
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className={'product-history box-history mt-4 mb-0'}>
                    <h3>İşlem Geçmişi</h3>
                    <Table
                        columns={this.product_history_column}
                        rowKey={record => record.transactionId}
                        dataSource={product_data}
                        pagination={{
                            ...pagination,
                            showSizeChanger: true,
                            pageSizeOptions: ['15', '30', '45', '60', '100'],
                        }}
                        loading={loading}
                        onChange={this.handleTableChange}
                    />
                </div>
            </>
        );
    }
}

export default withRouter(EarnPoints);
